import React from "react"
import PropTypes from "prop-types"
import { makeStyles } from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"
import NewsCard from "./NewsCard"
// import NewsList from "./NewsList"
//import AltNewsCard from "./AltNewsCards"
import ViewAllButton from "../LandingComponents/ViewAllButton"

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(0),
  },
  showAllroot: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(4),
  },
}))

export default function NewsGrid({ recentNews, showAll }) {
  const classes = useStyles()
  return (
    <div className={showAll ? classes.showAllroot : classes.root}>
      {/*<NewsList recentNews={recentNews} /> */}
      {/* Sub featured posts */}
      <Grid container spacing={4}>
        {recentNews.map(({ node }) => (
          <Grid item key={node.id} xs={12} md={6}>
            <NewsCard node={node} />
          </Grid>
        ))}
      </Grid>
      {/* End sub featured posts */}
      {!showAll && <ViewAllButton destination="/news" />}
    </div>
  )
}

NewsGrid.propTypes = {
  recentNews: PropTypes.array.isRequired,
  showAll: PropTypes.bool.isRequired,
}
